<template>
    <div class="current-action-wrapper">
        <div class="container">

            <div class="current-action">
                <span class="action"><span v-if="roomIndex" class="room-index">Room {{roomIndex}}: </span>{{action}}</span>


            </div>

            <p class="summary" v-if="summary">{{summary}}</p>
        </div>
    </div>
</template>

<script>


    export default {
        name: 'CurrentAction',
        props: {
            roomIndex: String,
            action: String,
            summary: String
        }

    }
</script>

<style>

    .current-action-wrapper {
        text-align: center;
    }

    .current-action {
        width: 100%;
        font-family: 'Playfair Display';
        font-size: 24px;
        position: relative;
        text-align: center;
        margin-bottom: 25px;
    }

        .current-action:after {
            width: 100%;
            content: '';
            height: 1px;
            background: #000;
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            z-index: 1;
            opacity: 0.1;
            display: none;
        }

        .current-action .action {
            padding: 0;
            background: #eae5e3;
            position: relative;
            z-index: 2;

        }

            .current-action .action .room-index {
                font-weight: bold;
            }

        .current-action .summary {
            margin-top: 30px;
        }

    .current-action-wrapper p.summary {
        font-size: 18px;
    }


    @media(min-width: 1025px) {

        .current-action {
            font-size: 36px;
         
        }

            .current-action:after {
                display: block;
            }
    }


    @media(min-width: 1200px){

        .current-action .action {
            padding: 0 45px;
        }
        }

</style>